import type { DynamicProductTileState } from "./types";
import { useFeaturedLookup } from "./use-featured-products";

/**
 * One product for the single Builder tile — the slider's batched read with
 * one id. Unlike the slider it KEEPS an out-of-stock product (the author
 * placed it deliberately); the tile greys it out instead of hiding it.
 * `productId === null` means none chosen yet: no fetch, `idle`.
 */
export function useDynamicProductTile(
  productId: string | null,
): DynamicProductTileState {
  const { lookup } = useFeaturedLookup(productId ? [productId] : []);
  if (!productId) return { status: "idle", product: undefined };
  const result = lookup?.[productId];
  if (!result) return { status: "loading", product: undefined };
  return result.kind === "ok"
    ? { status: "ready", product: result.product }
    : { status: result.kind, product: undefined };
}
